import { Component } from "@kluntje/core";
import { addClass, onEvent, removeClass, waitFor } from "@kluntje/js-utils/lib/dom-helpers";
import { VICPagination } from "Components/wec-m-pagination/wec-m-pagination";
import { HIDDEN, INVISIBLE, LOADED } from "Constants/cssClasses";
import { PAGINATION_CHANGED } from "Constants/eventTypes";

export class VICPageableComponent extends Component {
  pagination: VICPagination;

  get paginationActive(): boolean {
    return this.hasAttribute("pagination-active") && this.getAttribute("pagination-active") !== "false";
  }

  get itemsPerPage(): number {
    return 12;
  }

  get pageCount(): number {
    return Math.ceil(this.items.length / this.itemsPerPage);
  }

  get items(): Array<HTMLElement> {
    throw new Error("VICPageableComponent: override items-getter");
  }

  get itemsContainer(): HTMLElement | null {
    return null;
  }

  afterComponentRender() {
    if (this.paginationActive === false || this.pageCount <= 1) return;
    this.initPagination();
  }

  initPagination() {
    const pagination = document.createElement("wec-m-pagination") as VICPagination;
    addClass(pagination, "wec-m-pagination");
    pagination.setAttribute("page-count", this.pageCount.toString());

    onEvent(pagination, PAGINATION_CHANGED, this.handlePaginationChange, this);

    this.pagination = pagination;
    this.appendChild(pagination);
    addClass(this, LOADED);

    this.updateActiveItems();
  }

  async handlePaginationChange() {
    if (this.itemsContainer !== null) {
      addClass(this.itemsContainer, INVISIBLE);
      await waitFor(300);
      removeClass(this.itemsContainer, INVISIBLE);
    }

    this.updateActiveItems();
  }

  private updateActiveItems() {
    const activePage = this.pagination.activeItem || 0;
    addClass(this.items, HIDDEN);
    const activeItems = this.getItemsByPageIdx(activePage);
    removeClass(activeItems, HIDDEN);
  }

  private getItemsByPageIdx(pageIdx: number) {
    const itemsPerPage = this.itemsPerPage;
    const startingIdx = pageIdx * itemsPerPage;
    return this.items.slice(startingIdx, startingIdx + itemsPerPage);
  }
}
